import augmentYup from 'utils/forms/augmentYup';

// This file does not export anything, but code still gets run so the polyfills work
// Promise polyfill intended for fixing IE11/Calendar issue
require('es6-promise').polyfill();
require('whatwg-fetch');

augmentYup();
